import { render, staticRenderFns } from "./KanbanBoard.vue?vue&type=template&id=3b6929d9&scoped=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=js"
export * from "./KanbanBoard.vue?vue&type=script&lang=js"
import style0 from "./KanbanBoard.vue?vue&type=style&index=0&id=3b6929d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6929d9",
  null
  
)

export default component.exports